module.exports = __webpack_public_path__ + "media/assets/images/blog/customer_service_omnichannel-f2f94cc7388233d4142ad1322832349b.png";